// import React,{useEffect} from 'react'
// import HeroSection from '../components/discount_offers/HeroSection';
// import PricingSection from '../components/discount_offers/PricingSection';
// import YouthSection from '../components/discount_offers/YouthSection';


// const OffersPage = () => {
//   useEffect(() => {
//           // 👇️ scroll to top on page load
//           window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
//         }, []);

//   return (
//     <div style={{paddingTop: '66px'}}>
//       <HeroSection />
//       <div className='container'>
//         <PricingSection />
//         <YouthSection />
//       </div>

//     </div>
//   )
// }

// export default OffersPage


import React, { useEffect, useRef } from 'react'
import HeroSection from '../components/discount_offers/HeroSection';
import PricingSection from '../components/discount_offers/PricingSection';
import YouthSection from '../components/discount_offers/YouthSection';


const OffersPage = () => {
  // 1. Define refs for the sections
  const pricingRef = useRef(null);
  const youthRef = useRef(null);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  // 2. Define handler functions for scrolling
  const handleEntrepreneurClick = () => {
    pricingRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const handleYouthClick = () => {
    youthRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={{paddingTop: '66px'}}>
      {/* 3. Pass the handlers to HeroSection */}
      <HeroSection 
        onEntrepreneurClick={handleEntrepreneurClick}
        onYouthClick={handleYouthClick}
      />
      <div className='container'>
        {/* 4. Pass the refs to the respective sections */}
        <PricingSection ref={pricingRef} />
        <YouthSection ref={youthRef} />
      </div>
    </div>
  )
}

export default OffersPage